<template>
  <div class="container">

    <nav class="navbar navbar-expand-sm navbar-dark bg-primary mt-4 mb-4">
      <div class="collapse navbar-collapse flex-grow-1 text-right" id="myNavbar7">
        <ul class="navbar-nav ml-auto flex-nowrap">
          <li
            class="nav-item"
            @click="app.currentConfiguration.stage > 0 ? app.navigateToStageAsync('0'):''"
          >
            <span class="nav-link">Idioma / Mercado</span>
          </li>
          <li
            class="nav-item"
            @click="app.currentConfiguration.stage > 1 ? app.navigateToStageAsync('1'):''"
          >
            <span class="nav-link">Configuradores</span>
          </li>

          <li
            class="nav-item"
            @click="app.currentConfiguration.stage > 2 ? app.navigateToStageAsync('2'):''"
          >
            <span class="nav-link">Gama</span>
          </li>

          <li
            class="nav-item"
            @click="app.currentConfiguration.stage > 3 ? app.navigateToStageAsync('3'):''"
          >
            <span class="nav-link">El.principal</span>
          </li>

          <li
            class="nav-item"
            @click="app.currentConfiguration.stage > 4 ? app.navigateToStageAsync('4'):''"
          >
            <span class="nav-link">Resultado</span>
          </li>

          <li class="dropdown">
            <a class="dropdown-toggle" data-toggle="dropdown" href="#">
              <img src="images/login.png" style="width: 40px; height: auto;" />
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu">
              <div v-if="this.app.auth.isLogged">
                <li>
                  <a @click="app.routerPush('myConfigs')" class="dropdown-item" href="#">Config manager</a>
                </li>
                <li>
                  <a
                    @click="app.auth.logout()"
                    class="dropdown-item"
                    href="#"
                  >{{ $t('logout_btn') }}</a>
                </li>
              </div>

              <div v-else>
                <li>
                  <a
                    @click="app.auth.tryLogin()"
                    class="dropdown-item"
                    href="#"
                  >{{ $t('register_login') }}</a>
                </li>
              </div>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>


<style lang="scss">
.navbar-custom-color {
  background-color: crimson;
  color: white;
}
</style>


<script>

import { app } from "../application.js";
export default {
  name: "navigationbarWithLogin",
  components: {},
  data() {
    return {
      app: app
    };
  },

  methods: {

  }
};
</script>





